<template>
  <div id="app">
    <router-view v-title="title" />
  </div>
</template>
<script>

export default {
  name: 'App',
  data(){
    return {
      title: 'Smart Tile - Pay & Play'
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.stblue-background {
  background-color: #080035;
}
</style>
